module.exports = __webpack_public_path__ + "media/border-lole.54b5dd5a.mp4";